import { notification } from 'antd';

/** PingPulse header height (104px) + gap — popups sit below header icons */
export const ALERT_NOTIFICATION_TOP = 112;

export function configureAlertNotifications() {
  notification.config({
    placement: 'topRight',
    top: ALERT_NOTIFICATION_TOP,
  });
}

export function getDndUntil() {
  try {
    const v = localStorage.getItem('pingpulse_dnd_until');
    return v ? parseInt(v, 10) : 0;
  } catch {
    return 0;
  }
}

export function isAlertPopupEnabled() {
  try {
    return localStorage.getItem('pingpulse_alert_popup') !== 'false';
  } catch {
    return true;
  }
}
